// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6bd4553c","455":"08e437d5","977":"002546ef"}[chunkId] + ".chunk.js";
};